import React, { useState, useEffect } from "react";
import "../assets/css/orchestrated.css";

const cards = [
  { step: "01", title: "Parents don’t have time", desc: "Aabhyas Mitra tracks your child’s daily study automatically." },
  { step: "02", title: "Lack of positive study environment", desc: "We build a disciplined, guided study routine for your child.", active: true },
  { step: "03", title: "Don’t understand modern education methods", desc: "Our system simplifies modern learning for both parents and students." },
  { step: "04", title: "Can’t track if the child is studying or not", desc: "Live monitoring and regular progress visibility inside the app." },
  { step: "05", title: "Don’t know why marks are low", desc: "Detailed performance tracking pinpoints exact learning gaps." },
  { step: "06", title: "Communication gap with teachers", desc: "Transparent communication between Parent – Student – Mentor." },
  { step: "07", title: "Unnecessary educational expenses", desc: "Structured learning reduces trial-and-error expenses." },
];

const getVisibleCards = () => {
  if (window.innerWidth < 640) return 1;
  if (window.innerWidth < 1024) return 2;
  return 4;
};

export default function OrchestratedUI() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(getVisibleCards());

  useEffect(() => {
    const onResize = () => setVisible(getVisibleCards());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const maxIndex = Math.max(cards.length - visible, 0);

  return (
    <section className="orchestrated-wrapper" style={{ "--visible": visible }}>
      <header className="ow-hero">
        <span className="ow-badge">MISSION</span>
        <h1>
          Challenges Faced by Today’s <span>Parents.</span>
        </h1>
        <p>Aabhyas Mitra tracks your child’s daily study automatically.</p>
        <button>Explore More</button>
      </header>

      <div className="carousel">
        <button
          className="nav prev"
          onClick={() => setIndex(Math.max(index - 1, 0))}
          disabled={index === 0}
        >
          ‹
        </button>

        <div className="cards-window">
          <div
            className="cards"
            style={{ transform: `translateX(-${index * (100 / visible)}%)` }}
          >
            {cards.map((card, i) => (
              <div key={i} className={`card ${card.active ? "default" : ""}`}>
                <span className="step">{card.step}</span>
                <h3 className="card-title">{card.title}</h3>
                <div className="solution">
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          className="nav next"
          onClick={() => setIndex(Math.min(index + 1, maxIndex))}
          disabled={index === maxIndex}
        >
          ›
        </button>
      </div>

      <div className="indicators">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
}
